import React from "react";
import { Select } from "antd";
import { SelectConnections } from "./SelectConnection.styled";

export default function SelectConnection({
  changeConnection,
  connections,
  value,
}) {
  return (
    <SelectConnections
      showSearch
      allowClear
      optionFilterProp="children"
      placeholder="Выберите объект"
      onChange={changeConnection}
      value={value}
      dropdownMatchSelectWidth={false}
    >
      {connections?.map((item) => (
        <Select.Option key={item.id} value={item.id}>
          {item.name}
        </Select.Option>
      ))}
    </SelectConnections>
  );
}
